import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMarkup: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="markup, marker, highlight"><path d="M21.0099 20.25H3.75V17.9722L7.35294 11.75" stroke="currentColor" strokeWidth="1.5"/><path d="M14.9111 16.1666L12.3984 20.1916" stroke="currentColor" strokeWidth="1.5"/><path d="M11.1638 2.75L6.25 11.0463L16.0776 16.75L21.25 7.93518" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMarkup;
